import { getInvitationLinkDataCloudFunction } from '@/firebase/init';
import { AuthLoaderFunction, LoaderUserData } from '@/types/auth';
import { InvitationFromStore } from '@/types/types';
import { assert } from '@/utils/asserts';
import { FirebaseError } from 'firebase/app';
import { LoaderFunctionArgs } from 'react-router-dom';

export const handleInvitationLoader = (async (
  args: LoaderFunctionArgs,
  _user: LoaderUserData,
) => {
  void _user;
  const url = new URL(args.request.url);
  const hash = url.searchParams.get('hash') ?? url.searchParams.get('invitationId');
  const invitationType = url.searchParams.get('invitationType');
  assert(typeof hash === 'string', 'hash is required');
  assert(typeof invitationType === 'string', 'invitationType is required');
  assert(
    typeof invitationType === 'string' &&
      (invitationType === 'organization' || invitationType === 'workspace'),
    'invitationType is required',
  );
  try {
    return (
      await getInvitationLinkDataCloudFunction({
        hash,
        invitationType:
          invitationType === 'organization' ? 'organizations' : 'workspaces',
      })
    ).data as InvitationFromStore<'organization' | 'workspace'>;
  } catch (e) {
    console.error(e);
    const error = e as FirebaseError;
    return error;
  }
}) satisfies AuthLoaderFunction;
